import { Component, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { IntegrationType } from 'app/automations/integrations-models';
import { IntegrationsService } from 'app/shared/services/integrations.service';

@Component({
  selector: 'app-flyout-automations',
  templateUrl: './flyout-automations.component.html',
  styleUrl: './flyout-automations.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutAutomationsComponent implements OnDestroy {
  @Input() flyoutOpeningData;

  public customIntegrationData: { name?: string; iconUrl?: string };
  private subscription: Subscription;

  constructor(private integrationsService: IntegrationsService) {
    this.subscription = this.integrationsService.activeIntegrationsBS.subscribe((integrations) => {
      const customIntegration = integrations?.find((i) => i.type === IntegrationType.Custom);
      this.customIntegrationData = customIntegration?.data;
    });
    if (!this.integrationsService.activeIntegrationsBS.getValue()) {
      this.integrationsService.loadActiveIntegrations();
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
